<template>
    <v-row>
        <v-col cols="12" sm="6" offset-sm="3">
            <v-card class="elevation-12">
                <v-toolbar class='grey darken-3' dark>
                    <v-toolbar-title>Sign Up</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form>
                        <v-text-field prepend-icon="person" name="login" label="Email Address" type="text" autocomplete="username"></v-text-field>
                        <v-text-field prepend-icon="lock" name="password" label="Password" id="password" autocomplete="new-password" type="password"></v-text-field>
                        <v-checkbox v-model="emailme" label="I would like to receive updates about new features and the service status" ></v-checkbox>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="orange darken-4" dark>Sign Up</v-btn>
                </v-card-actions>
                <v-card-text>
                    By clicking Sign Up you agree to our <a href='/TermsOfService'>Terms of Service</a>.
                </v-card-text>
            </v-card>
            <div id="login">Already have an account?  <v-btn class="orange darken-4" dark to="/login">Login</v-btn></div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        data () {
            return {
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                emailme: false,
                is_admin: null
            }
        }
    };
</script>

<style>
.elevation-12 {
    margin-top: 3rem;
}

#login {
    margin-top: 3rem;
    text-align: center;
    font-weight: bold;
}
</style>
